import { c as _c } from "react-compiler-runtime";
import { forwardRef } from 'react';
import { pickDataAttributes } from '../../utils/pickDataAttributes';
import { AvatarRoot, AvatarFallback, AvatarImage } from './primitives';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * `Avatar` configured from flat `src`, `alt`, and `fallback` props, so you don't
 * compose `AvatarImage` and `AvatarFallback` by hand.
 *
 * @see {@link AvatarRoot | Avatar}
 */
export const Avatar = /*#__PURE__*/forwardRef((t0, ref) => {
  const $ = _c(23);
  const {
    src,
    alt,
    fallback,
    fallbackDelay,
    backgroundColor,
    shape,
    size,
    truncated,
    id,
    ariaLabel,
    ariaLabelledby,
    ariaDescribedby,
    ariaDescription,
    dataTestId,
    dataAttributes
  } = t0;
  const t1 = id === null || id === void 0 ? void 0 : id.root;
  const t2 = ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.root;
  const t3 = ariaLabelledby === null || ariaLabelledby === void 0 ? void 0 : ariaLabelledby.root;
  const t4 = ariaDescribedby === null || ariaDescribedby === void 0 ? void 0 : ariaDescribedby.root;
  const t5 = ariaDescription === null || ariaDescription === void 0 ? void 0 : ariaDescription.root;
  let t6;
  if ($[0] !== dataAttributes) {
    t6 = pickDataAttributes(dataAttributes);
    $[0] = dataAttributes;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const t7 = dataTestId === null || dataTestId === void 0 ? void 0 : dataTestId.root;
  let t8;
  if ($[2] !== alt || $[3] !== src) {
    t8 = src != null && /*#__PURE__*/_jsx(AvatarImage, {
      src: src,
      alt: alt !== null && alt !== void 0 ? alt : ""
    });
    $[2] = alt;
    $[3] = src;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== fallback || $[6] !== fallbackDelay) {
    t9 = fallback != null && /*#__PURE__*/_jsx(AvatarFallback, {
      delay: fallbackDelay,
      children: fallback
    });
    $[5] = fallback;
    $[6] = fallbackDelay;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== backgroundColor || $[9] !== ref || $[10] !== shape || $[11] !== size || $[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8 || $[20] !== t9 || $[21] !== truncated) {
    t10 = /*#__PURE__*/_jsxs(AvatarRoot, Object.assign({
      ref: ref,
      backgroundColor: backgroundColor,
      shape: shape,
      size: size,
      truncated: truncated,
      id: t1,
      "aria-label": t2,
      "aria-labelledby": t3,
      "aria-describedby": t4,
      "aria-description": t5
    }, t6, {
      "data-test-id": t7,
      children: [t8, t9]
    }));
    $[8] = backgroundColor;
    $[9] = ref;
    $[10] = shape;
    $[11] = size;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = truncated;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
});
Avatar.displayName = 'Avatar';